import { apiFetch, readJson, readJsonArray, readErrorMessage } from './client';

export interface CompanyHoliday {
  id: string;
  holidayDate: string;
  name: string;
}

function qs(query: Record<string, string | number | undefined>): string {
  const parts = Object.entries(query).filter(([, v]) => v !== undefined && v !== '');
  if (parts.length === 0) return '';
  return `?${parts.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')}`;
}

export async function listCompanyHolidaysForRange(from: string, to: string): Promise<CompanyHoliday[]> {
  const res = await apiFetch(`/api/time-off/company-holidays${qs({ from, to })}`);
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJsonArray<CompanyHoliday>(res);
}

export async function listAdminCompanyHolidays(year: number): Promise<CompanyHoliday[]> {
  const res = await apiFetch(`/api/admin/time-off/company-holidays${qs({ year })}`);
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJsonArray<CompanyHoliday>(res);
}

export async function createAdminCompanyHoliday(payload: {
  holidayDate: string;
  name: string;
}): Promise<CompanyHoliday> {
  const res = await apiFetch('/api/admin/time-off/company-holidays', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<CompanyHoliday>(res);
}

export async function updateAdminCompanyHoliday(
  id: string,
  payload: { holidayDate?: string; name?: string }
): Promise<CompanyHoliday> {
  const res = await apiFetch(`/api/admin/time-off/company-holidays/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<CompanyHoliday>(res);
}

export async function deleteAdminCompanyHoliday(id: string): Promise<void> {
  const res = await apiFetch(`/api/admin/time-off/company-holidays/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(await readErrorMessage(res));
}
